import React from 'react';

import { KeyboardShortcutContext } from '@neptune/shared/keyboard-domain';

export const useKeyboardOpenModalsRegistry = () => {
  const { registerOpenModal } = React.useContext(KeyboardShortcutContext);

  return registerOpenModal;
};
